import { Injectable } from '@angular/core';

import { from, isObservable, Observable, of } from 'rxjs';
import { every, mergeAll } from 'rxjs/operators';

// Angular's own ɵisPromise (an internal, unstable API — `ɵ`-prefixed exports are not part of the
// public surface and can be removed without notice, as happened for ɵisObservable/ɵisPromise in
// Angular 16) is replaced here by the same duck-typed check it used internally: anything
// thenable, not just a native Promise (matters for e.g. an AngularJS `$q` promise, per the
// existing comment below).
function isPromise(value: unknown): value is Promise<unknown> {
    return !!value && typeof (value as { then?: unknown }).then === 'function';
}

/**
 * Service for Rxjs utils.
 *
 * @export
 * @class RxjsService
 */
@Injectable()
export class RxjsService {
    wrapIntoObservable(value) {
        if (isObservable(value)) {
            return value;
        }
        if (isPromise(value)) {
            // Use `Promise.resolve()` to wrap promise-like instances.
            // Required ie when a Resolver returns a AngularJS `$q` promise to correctly trigger the
            // change detection.
            return from(Promise.resolve(value));
        }
        return of(value);
    }

    andObservables(observables): Observable<any> {
        return observables.pipe(
            mergeAll(),
            every(result => result === true),
        );
    }
}
